import { Box } from '@mui/material';
import { TagItem } from 'src/features/sites/components/tag-item';
type Props = {
  formttedTags: any;
  liveDataComplete: any;
  isMobile: boolean;
};

export const LiveTagsList = ({ formttedTags, isMobile, liveDataComplete }: Props) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        // flex: 1,
      }}
    >
      {formttedTags
        ?.filter((_: any, index: number) => index % 2 === 0)
        .map((tag: any) => (
          <TagItem
            key={tag.id}
            testId={`tag-item-${tag.id}`}
            tag={tag}
            isMobile={isMobile}
            liveDataComplete={liveDataComplete}
            isLiveDataWidget
            isLiftStationMobile={isMobile}
            isLiftStation
            alignRight
          />
        ))}
    </Box>

    {formttedTags?.length > 1 && (
      <Box
        sx={{
          width: '1px',
          maxWidth: '1px',
          backgroundColor: 'grey',
          marginRight: '5px',
          alignSelf: 'stretch',
        }}
      />
    )}

    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        minWidth: 0,
      }}
    >
      {formttedTags
        ?.filter((_: any, index: number) => index % 2 === 1)
        .map((tag: any) => (
          <Box
            key={tag.id}
            sx={{
              display: 'inline-block',
              textAlign: 'right',
            }}
          >
            <TagItem
              testId={`tag-item-${tag.id}`}
              tag={tag}
              isMobile={isMobile}
              liveDataComplete={liveDataComplete}
              isLiveDataWidget
              isLiftStationMobile={isMobile}
              isLiftStation
            />
          </Box>
        ))}
    </Box>
  </Box>
);
